(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["collection-pills"] && !Shopify.designMode) return;
  try {
    (function () {
    try {
      window.__collectionPillsDebugBoot = true;
      document.documentElement.dataset.collectionPillsBoot = 'true';
      if (document.body) document.body.classList.add('collection-pills-js-booted');
      console.warn('[collection-pills] script boot', { booted: window.__collectionPillsDebugBoot });
    } catch (e) {
      // If even this fails, we still want to know something went wrong.
      // eslint-disable-next-line no-console
      console.error('[collection-pills] boot prelude failed', e);
    }
    const SECTION_ATTR = 'data-main-collection-section';
    let lastKnownPillsMarkup = null;

    const clearAllPillsLoadingState = () => {
      document.querySelectorAll('[data-collection-pills]').forEach((el) => {
        el.classList.remove('collection-pills--loading');
        el.querySelectorAll('[aria-busy="true"]').forEach((busyEl) => busyEl.removeAttribute('aria-busy'));
      });
    };

    const findMainCollectionSectionId = () => {
      const el = document.querySelector('[' + SECTION_ATTR + ']');
      if (!el) return null;
      const sectionEl = el.closest('.shopify-section');
      if (!sectionEl || !sectionEl.id) return null;
      return sectionEl.id.replace('shopify-section-', '');
    };

    const replaceMainCollectionSectionFromHtml = (html, sectionId) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const incoming = doc.querySelector('#shopify-section-' + CSS.escape(sectionId));
      const current = document.querySelector('#shopify-section-' + CSS.escape(sectionId));
      if (!incoming || !current) return false;

      // Keep current pills UI if incoming section does not render one.
      const currentPills = current.querySelector('[data-collection-pills]');
      const preservePills = currentPills && !incoming.querySelector('[data-collection-pills]');
      const preservedPillsNode = preservePills ? currentPills.cloneNode(true) : null;
      if (preservedPillsNode) {
        preservedPillsNode.classList.remove('collection-pills--loading');
        preservedPillsNode.querySelectorAll('[aria-busy="true"]').forEach((el) => el.removeAttribute('aria-busy'));
      }

      current.innerHTML = incoming.innerHTML;

      if (!current.querySelector('[data-collection-pills]')) {
        let pillsNodeToInsert = preservedPillsNode;

        if (!pillsNodeToInsert && lastKnownPillsMarkup) {
          try {
            const tempDoc = parser.parseFromString(lastKnownPillsMarkup, 'text/html');
            pillsNodeToInsert = tempDoc.querySelector('[data-collection-pills]');
            if (pillsNodeToInsert) {
              pillsNodeToInsert.classList.remove('collection-pills--loading');
              pillsNodeToInsert.querySelectorAll('[aria-busy="true"]').forEach((el) => el.removeAttribute('aria-busy'));
            }
          } catch (e) {
            // ignore parse errors and continue gracefully
          }
        }

        if (pillsNodeToInsert) {
          const wrapper = current.querySelector('.collection-wrapper');
          if (wrapper) {
            wrapper.insertBefore(pillsNodeToInsert, wrapper.firstChild);
          }
        }
      }

      clearAllPillsLoadingState();

      return true;
    };

    const fetchAndSwap = async (targetUrl) => {
      const sectionId = findMainCollectionSectionId();
      if (!sectionId) {
        throw new Error('Main collection section id not found');
      }

      const url = new URL(targetUrl, window.location.origin);
      url.searchParams.set('section_id', sectionId);

      const res = await fetch(url.toString(), { credentials: 'same-origin' });
      if (!res.ok) throw new Error('Fetch failed: ' + res.status);
      const html = await res.text();

      const swapped = replaceMainCollectionSectionFromHtml(html, sectionId);
      if (!swapped) throw new Error('Section not found in response');
    };

    const initRoot = (root) => {
      if (!root || root.dataset.init === 'true') return;
      root.dataset.init = 'true';
      root.classList.remove('collection-pills--loading');
      root.querySelectorAll('[aria-busy="true"]').forEach((el) => el.removeAttribute('aria-busy'));
      try {
        lastKnownPillsMarkup = root.outerHTML;
      } catch (e) {
        // ignore serialization issues
      }
      console.warn('[collection-pills] initRoot', { uid: root.id, pills: root.querySelectorAll('[data-pill]').length });

      const showAll = root.dataset.showAll === 'true';
      const autoOpenFirst = root.dataset.autoOpenFirst !== 'false';
      const track = root.querySelector('[data-pills-track]');
      const pills = Array.from(root.querySelectorAll('[data-pill]'));
      const panels = Array.from(root.querySelectorAll('[data-pill-panel]'));
      if (!pills.length) return;
      clearAllPillsLoadingState();

      const storageKey =
        'collection-pills:selected:' + root.id + ':' + window.location.pathname.replace(/\/+$/, '');

      const toIndex = (el) => {
        if (!el || !el.dataset) return -1;
        const raw = el.dataset.index;
        const n = Number(raw);
        return Number.isFinite(n) ? n : -1;
      };

      const toPanelIndex = (el) => {
        if (!el || !el.dataset) return -1;
        const raw = el.dataset.panelIndex;
        const n = Number(raw);
        return Number.isFinite(n) ? n : -1;
      };

      const pillByHandle = new Map(
        pills
          .map((btn) => [btn.dataset.handle || null, btn])
          .filter((pair) => pair[0] !== null)
      );

      const getServerActive = () => {
        const activeFromServer = pills.find((b) => b.classList.contains('is-active'));
        if (!activeFromServer) return { handle: null, index: -1 };
        return {
          handle: activeFromServer.dataset.handle || null,
          index: toIndex(activeFromServer),
        };
      };

      const getDesiredHandle = () => {
        let storedHandle = null;
        try {
          storedHandle = window.sessionStorage.getItem(storageKey);
        } catch (e) {
          // Ignore storage issues (private mode, blocked cookies, etc.)
        }

        // Debug selection state
        console.warn('[collection-pills] desiredHandle inputs', {
          uid: root.id,
          showAll,
          autoOpenFirst,
          storageKey,
          storedHandle,
        });

        if (storedHandle && pillByHandle.has(storedHandle)) return storedHandle;

        const { handle: serverHandle } = getServerActive();
        if (serverHandle) return serverHandle;

        if (!showAll && autoOpenFirst) {
          const firstPill = pills.find((btn) => toIndex(btn) === 0);
          return firstPill && firstPill.dataset ? firstPill.dataset.handle || null : null;
        }

        return null;
      };

      const setActive = (index, opts = { scroll: true, focus: false }) => {
        // Never allow "no selection" to hide all content when we have real pills.
        // `index === -1` corresponds to the optional "All" pill.
        let safeIndex = index;
        if (safeIndex === -1) {
          const firstReal = pills.find((btn) => toIndex(btn) >= 0);
          safeIndex = firstReal ? toIndex(firstReal) : -1;
        }

        pills.forEach((btn) => {
          const active = toIndex(btn) === safeIndex;
          btn.classList.toggle('is-active', active);
          btn.setAttribute('aria-selected', active ? 'true' : 'false');
          btn.tabIndex = active ? 0 : -1;
        });

        if (panels.length) {
          panels.forEach((panel) => {
            const panelIndex = toPanelIndex(panel);
            panel.hidden = panelIndex !== safeIndex;
          });
        }

        const activeBtn = pills.find((btn) => toIndex(btn) === safeIndex);
        if (!activeBtn) return;
        if (opts.scroll && track) {
          const target = activeBtn.offsetLeft - track.clientWidth / 2 + activeBtn.clientWidth / 2;
          track.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
        }
        if (opts.focus) activeBtn.focus();
      };

      const { handle: serverActiveHandle } = getServerActive();
      const desiredHandle = getDesiredHandle();
      const desiredPill = desiredHandle ? pillByHandle.get(desiredHandle) : null;
      const desiredIndex = desiredPill ? toIndex(desiredPill) : -1;

      console.warn('[collection-pills] init selection', {
        uid: root.id,
        serverActiveHandle,
        desiredHandle,
        desiredIndex,
        pillsCount: pills.length,
        panelsCount: panels.length,
      });

      setActive(desiredIndex, { scroll: true, focus: false });

      // Optional behavior: when landing on the parent collection (no active child yet),
      // auto-load the first pill's collection products without changing URL.
      if (!showAll && autoOpenFirst && !serverActiveHandle && desiredPill) {
        const desiredHref = desiredPill.getAttribute('href');
        if (desiredHref) {
          root.classList.add('collection-pills--loading');
          fetchAndSwap(desiredHref)
            .then(() => {
              document.querySelectorAll('[data-collection-pills]').forEach((r) => {
                r.dataset.init = 'false';
                initRoot(r);
              });
              clearAllPillsLoadingState();
            })
            .catch((err) => {
              console.error('[collection-pills] auto-open-first fetch failed', err);
            })
            .finally(() => {
              clearAllPillsLoadingState();
            });
        }
      }

      root.addEventListener('click', async (e) => {
        const btn = e.target.closest('[data-pill]');
        if (!btn) return;

        const href = btn.getAttribute('href');
        if (!href) return;

        e.preventDefault();

        const desiredHandle = btn.dataset.handle || null;
        const desiredIndex = toIndex(btn);
        const { handle: currentServerHandle } = getServerActive();

        console.warn('[collection-pills] pill click', {
          uid: root.id,
          clickedHandle: desiredHandle,
          clickedIndex: desiredIndex,
          currentServerHandle,
          href,
        });

        try {
          window.sessionStorage.setItem(storageKey, desiredHandle);
        } catch (err) {
          // ignore
        }

        setActive(desiredIndex, { scroll: true, focus: false });

        // Avoid unnecessary fetch if clicking the active pill.
        if (desiredHandle && desiredHandle === currentServerHandle) return;

        root.classList.add('collection-pills--loading');
        btn.setAttribute('aria-busy', 'true');

        try {
          console.warn('[collection-pills] click fetchAndSwap start', { uid: root.id, href });
          await fetchAndSwap(href);
          console.warn('[collection-pills] click fetchAndSwap done', { uid: root.id });
          // Re-init any new pills markup after swap
          document.querySelectorAll('[data-collection-pills]').forEach((r) => {
            r.dataset.init = 'false';
            initRoot(r);
          });
          clearAllPillsLoadingState();
        } catch (err) {
          console.error('[collection-pills] navigation failed', err);
        } finally {
          clearAllPillsLoadingState();
        }
      });

      root.addEventListener('keydown', (e) => {
        const btn = e.target.closest('[data-pill]');
        if (!btn) return;
        const currentPos = pills.indexOf(btn);
        if (currentPos === -1) return;
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          const dir = e.key === 'ArrowRight' ? 1 : -1;
          const nextPos = (currentPos + dir + pills.length) % pills.length;
          const nextBtn = pills[nextPos];
          if (!nextBtn) return;
          const nextIndex = toIndex(nextBtn);
          const nextHandle = nextBtn.dataset.handle || null;
          const { handle: currentServerHandle } = getServerActive();
          try {
            window.sessionStorage.setItem(storageKey, nextHandle);
          } catch (err) {
            // ignore
          }
          console.warn('[collection-pills] arrow nav', {
            uid: root.id,
            fromPos: currentPos,
            toPos: nextPos,
            nextHandle,
            nextIndex,
            currentServerHandle,
          });
          setActive(nextIndex, { scroll: true, focus: true });
          if (nextHandle && nextHandle !== currentServerHandle) {
            const nextHref = nextBtn.getAttribute('href');
            if (nextHref) {
              (async () => {
                root.classList.add('collection-pills--loading');
                nextBtn.setAttribute('aria-busy', 'true');
                try {
                  console.warn('[collection-pills] arrow fetchAndSwap start', { uid: root.id, nextHref });
                  await fetchAndSwap(nextHref);
                  console.warn('[collection-pills] arrow fetchAndSwap done', { uid: root.id });
                  document.querySelectorAll('[data-collection-pills]').forEach((r) => {
                    r.dataset.init = 'false';
                    initRoot(r);
                  });
                  clearAllPillsLoadingState();
                } catch (err) {
                  console.error('[collection-pills] keyboard navigation failed', err);
                } finally {
                  clearAllPillsLoadingState();
                }
              })();
            }
          }
        }
      });
    };

    // boot
    const roots = document.querySelectorAll('[data-collection-pills]');
    console.log('[collection-pills] boot roots', roots.length);
    roots.forEach(initRoot);
    clearAllPillsLoadingState();

    // No popstate handling needed since URL/history is not mutated by pill clicks.
  })();
  } catch(e) { console.error(e); }
})();

})();
